import { useNavigate } from 'react-router-dom';
import "../css/SamplesSection.css";
import colors from '../colors';

function SamplesSection()
{

    const navigate = useNavigate();

    return(
        <div id="sample-section">


      <h2>
        با
        &nbsp;
        {process.env.REACT_APP_PROJECT_NAME}
        &nbsp;
        به کجاها می رسی؟
      </h2>

    
      <span className="sample-subtitle">
          <div>
            <span style={{display:'flex',alignItems:'center'}}>
              <i className="pi-star-fill pi pi-spin"></i>
              <h3 className="subtitle">اول از همه اینکه، هزینه های سئوی وبسایتت نصف میشه!</h3>
            </span>
            <span style={{marginRight:'30px',fontSize:'18px'}}> 
              تمام محتوای وبسایت زیر با سرویس های 
              &nbsp;
              {process.env.REACT_APP_PROJECT_NAME}
              تولید شده و این تغییرات فقط برای 3 ماهه:
              &nbsp;
            </span>
          </div>
      </span>


      <img className="sample-image" src={ require('../images/sample1.webp') } alt={process.env.REACT_APP_ALT} />


      <span className="sample-subtitle">
          <div>
            <span style={{display:'flex',alignItems:'center'}}>
              <i className="pi-star-fill pi pi-spin"></i>
              <h3 className="subtitle">دوم اینکه، همه چی اتوماته!</h3>
            </span>
            <span style={{marginRight:'30px',fontSize:'18px'}}> 
              فقط کافیه کلمه کلیدی انتخاب کنی، مقاله ها اتومات منتشر میشن، لینک دهی داخلی انجام میشه، رتبه گوگل هر مقاله رو میتونی ببینی:
            </span>
          </div>
      </span>



      <img className="sample-image" src={ require('../images/sample2.webp') } alt={process.env.REACT_APP_ALT}/>

      

        <div>
          <button 
              style={{marginTop:"50px"}} 
              className="login-button"
              onClick={()=>navigate("/register")}
              >
                ثبت نام کنید، امتحان کنید
                </button>
          </div>
      
      
      
      </div>
    );
}

export default SamplesSection;